/*
 * @Author: your name
 * @Date: 2021-09-30 14:25:59
 * @LastEditTime: 2021-10-20 17:27:44
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ocr/src/store/modules/Log/store.js
 */
export default {
  userInfo: {
    name: 'log',
    address: 'beijing'
  },
  logData: {
    name: '无数据；'
  },
  isCustom: false
}
